// extracted by mini-css-extract-plugin
export default {"balance":"Balance_balance__tUx3D","balanceTitle":"Balance_balanceTitle__UY4qb","balanceValue":"Balance_balanceValue__xazyO","symbol":"Balance_symbol__CEPn9"};